module.exports = __webpack_public_path__ + "img/franchising_review_ava_1.586abd1c.png";